import React, { useEffect, useState } from "react";
import { Clock3 } from "lucide-react";

const formatDuration = (milliseconds) => {
  if (milliseconds <= 0) return "Credit is being added now";
  const totalSeconds = Math.ceil(milliseconds / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours || days) parts.push(`${hours}h`);
  parts.push(`${minutes}m`);
  parts.push(`${seconds}s`);
  return parts.join(" ");
};

export const EiraPointsCountdown = ({
  nextAvailableAt,
  nextAvailablePoints,
  pendingPoints,
  className = "",
}) => {
  const [now, setNow] = useState(Date.now());
  const target = nextAvailableAt ? new Date(nextAvailableAt).getTime() : Number.NaN;
  const hasTimer = Number.isFinite(target) && pendingPoints > 0;

  useEffect(() => {
    if (!hasTimer) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [hasTimer]);

  if (!pendingPoints) return null;
  if (!hasTimer) {
    return (
      <p className={`text-xs text-[#8C6D46] ${className}`} data-testid="eira-points-pending-status">
        Pending Eira Points are being processed.
      </p>
    );
  }

  const duration = formatDuration(target - now);
  const pointsLabel = nextAvailablePoints || pendingPoints;
  return (
    <div
      className={`flex items-start gap-2 border-l-2 border-[#D99B26] bg-[#FFF8E6] px-3 py-2 text-left ${className}`}
      data-testid="eira-points-pending-countdown"
    >
      <Clock3 size={15} className="mt-0.5 shrink-0 text-[#8C6D46]" />
      <div>
        <p className="text-xs font-semibold text-[#5F4A28]">
          Next {pointsLabel} Eira Points credit in
        </p>
        <p className="mt-0.5 font-mono text-sm font-bold text-[#1E2A24]" data-testid="eira-points-countdown-value">
          {duration}
        </p>
      </div>
    </div>
  );
};